var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "loginbg", staticStyle: { display: "none" } },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-9 col-md-7 col-lg-5 mx-auto" }, [
              _c("div", { staticClass: "loginform" }, [
                _c("div", { staticClass: "loginlogo" }, [
                  _c("img", {
                    attrs: {
                      src: "static/images/login-logo.png",
                      alt: "Velocity Vehicle Group"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("form", [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "exampleInputEmail1" } }, [
                      _vm._v("Username")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "username",
                        id: "exampleInputEmail1",
                        placeholder: "Enter Username"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "exampleInputPassword1" } }, [
                      _vm._v("Password")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "form-control",
                      attrs: {
                        type: "password",
                        name: "password",
                        id: "exampleInputPassword1",
                        placeholder: "Enter password"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check" }, [
                    _c(
                      "label",
                      {
                        staticClass:
                          "checkbox-inline checkbox-bootstrap checkbox-lg"
                      },
                      [
                        _c("input", { attrs: { type: "checkbox" } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "checkbox-placeholder" }),
                        _vm._v(
                          "\n                                Remember me\n                                "
                        ),
                        _c("a", { attrs: { href: "#" } }, [
                          _vm._v("Not Registered? ")
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { id: "loginbtn", type: "submit" }
                      },
                      [_vm._v("Login")]
                    ),
                    _vm._v(" "),
                    _c("a", { attrs: { href: "#" } }, [
                      _vm._v("Forgot password?")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef68022e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef68022e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 